export const TABLE_WATERMARK_ENABLED = true;

export const TABLE_WATERMARK_POSITIONS = {
  default: {
    left: '50%',
    leftMobile: '48%',
  },
  nbu: {
    left: '68%',
    leftMobile: '62%',
  },
  average: {
    left: '55%',
    leftMobile: '48%',
  },
  cash: {
    left: '56%',
    leftMobile: '56%',
  },
  converter: {
    left: '50%',
    leftMobile: '50%',
  },
  banks: {
    left: '50%',
    leftMobile: '50%',
  },
  mb: {
    left: '57%',
    leftMobile: '66%',
  },
};
